module.exports = __webpack_public_path__ + "static/media/hiw20.8c75d6ca.svg";